import { Form, InputNumber, Table } from "antd";

const HipJoint = ({ initial = false }) => {
  const inputStyle = {
    width: "100%",
    maxWidth: "120px",
    textAlign: "center",
  };
  const columns = [
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
    },
    {
      title: "Left Active",
      dataIndex: "left_active",
      key: "left_active",
      render: (text, record) => (
        <Form.Item
          name={
            initial
              ? ["rom", "hip_joint", `left_active_${record.value}`]
              : ["hip_joint", `left_active_${record.value}`]
          }
        >
          <InputNumber
            max={record.max}
            min={record.min}
            placeholder={`${record.min} to ${record.max}`}
            style={inputStyle}
          />
        </Form.Item>
      ),
    },
    {
      title: "Left Passive",
      dataIndex: "left_passive",
      key: "left_passive",
      render: (text, record) => (
        <Form.Item
          name={
            initial
              ? ["rom", "hip_joint", `left_passive_${record.value}`]
              : ["hip_joint", `left_passive_${record.value}`]
          }
        >
          <InputNumber
            max={record.max}
            min={record.min}
            placeholder={`${record.min} to ${record.max}`}
            style={inputStyle}
          />
        </Form.Item>
      ),
    },
    {
      title: "Right Active",
      dataIndex: "right_active",
      key: "right_active",
      render: (text, record) => (
        <Form.Item
          name={
            initial
              ? ["rom", "hip_joint", `right_active_${record.value}`]
              : ["hip_joint", `right_active_${record.value}`]
          }
        >
          <InputNumber
            max={record.max}
            min={record.min}
            placeholder={`${record.min} to ${record.max}`}
            style={inputStyle}
          />
        </Form.Item>
      ),
    },
    {
      title: "Right Passive",
      dataIndex: "right_passive",
      key: "right_passive",
      render: (text, record) => (
        <Form.Item
          name={
            initial
              ? ["rom", "hip_joint", `right_passive_${record.value}`]
              : ["hip_joint", `right_passive_${record.value}`]
          }
        >
          <InputNumber
            max={record.max}
            min={record.min}
            placeholder={`${record.min} to ${record.max}`}
            style={inputStyle}
          />
        </Form.Item>
      ),
    },
  ];

  const data = [
    {
      key: "1",
      action: "Flexion",
      value: "flexion",
      max: 120,
      min: 0,
    },
    {
      key: "2",
      action: "Extension",
      value: "extension",
      max: 30,
      min: 0,
    },
    {
      key: "3",
      action: "Abduction",
      value: "abduction",
      max: 45,
      min: 0,
    },
    {
      key: "4",
      action: "Adduction",
      value: "adduction",
      max: 30,
      min: 0,
    },
    {
      key: "5",
      action: "Lateral Rotation",
      value: "lateral_rotation",
      max: 45,
      min: 0,
    },
    {
      key: "6",
      action: "Medial Rotation",
      value: "medial_rotation",
      max: 45,
      min: 0,
    },
  ];
  return (
    <>
      <Table columns={columns} dataSource={data} pagination={false} rowKey="key" scroll={{ x: "max-content" }}/>
    </>
  );
};

export default HipJoint;